// extracted by mini-css-extract-plugin
export default {"UpsellBannerOcticon":"UpsellBanner-module__UpsellBannerOcticon__YbeEHGy","UpsellBannerHeading":"UpsellBanner-module__UpsellBannerHeading__up_fyQh"};